import { GetterTree } from "vuex";
import { GettersTypes } from "./getters-types";
import { AuthGettersTypes, AuthStateType } from "./interface";

export const getters: GetterTree<AuthStateType, AuthStateType> & AuthGettersTypes = {
  [GettersTypes.IS_LOGGED_IN]: (state: AuthStateType): boolean => {
    return state.isLoggedIn;
  },
  [GettersTypes.GET_VIEW]: (state: AuthStateType): string | null => {
    return state.view;
  }
};
